import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IIdentity } from "@comunicare/comunicare-interfaces";
import moment from "moment";

export class IdentityStatusChangeHistoricDataSource extends MatTableDataSourceExtended<IIdentity> {
  sortingDataAccessor = (data: IIdentity, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "identityChangeStatus":
        return data.status;
      case "verification":
        return data.verification;
      case "verificationMethod":
        return data.method;
      case "modificationType":
        return data.modificationType;
      case "periodStart":
        return moment(data.period.start).format();
      case "periodEnd":
        return moment(data.period?.end).format();
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(data: IIdentity[]): void {
    this.data = data;
  }
}
